"use strict";

angular.module('app.modals.deviceRoomPicker', [])

/*



 */

    .factory('deviceRoomPickerModal', ['ModalService', function (ModalService) {
        return function (filterObject) {
            return ModalService.showModal({
                templateUrl: "views/modals/deviceRoomPicker.html",
                controller: 'deviceRoomPickerModalCtrl',
                inputs: {
                    filterObject: filterObject
                }
            });


        }
    }])
    .controller("deviceRoomPickerModalCtrl", ['$scope', '$rootScope', 'filterObject', 'close', '__Device', 'conf_guidEmpty', 'ENUM',
        function ($scope, $rootScope, filterObject, close, __Device, conf_guidEmpty, ENUM) {



            var filterDefaults = {
                // Property Exists, we get the filter
                DeviceType: {
                    // Hide DeviceTypes : array of Ids
                    hide: [],
                    // Show Only DeviceTypes : array of Ids
                    show: [],
                    // single / multiple
                    selectable: 'single',
                    // hide PreSelected DeviceTypes
                    selected: undefined,
                    // hide SelectNavigation
                    hideNav: false,
                    // DisplayButton SystemDevice
                    hideButtonSystemDevice: false,
                    // User has to select an Entry
                    mustSelectDeviceType: true,
                    // DeviceTypelist
                    list: []
                }
            };
            $scope.selectedDeviceType = [];
            $scope.close = function () {
                close();
            };
            $scope.$watch('selectedDeviceType', function () {
                var selectedDeviceType;
                if ($scope.selectedDeviceType[0] && typeof $scope.selectedDeviceType[0] !== 'number') {

                    selectedDeviceType = [$scope.selectedDeviceType[0].$pk];
                } else {

                    selectedDeviceType = $scope.selectedDeviceType;
                }

                if ($scope.filterObject.DeviceType) {
                    $scope.filterObject.DeviceType.show = selectedDeviceType;
                    $scope.filterObject.DeviceType.selected = selectedDeviceType;
                    if($scope.filterObject.Device) {
                        $scope.filterObject.Device.show = selectedDeviceType;
                    }
                }
            }, true);

            $scope.save = function () {
                var result = {};
                if ($scope.filterResult && $scope.filterResult.Device) {
                    result.Device = $scope.filterResult.Device;
                }

                if ($scope.filterResult && $scope.filterResult.MenuEntry) {
                    result.MenuEntry = $scope.filterResult.MenuEntry;
                }

                if ($scope.filterObject.DeviceType && $scope['selectedDeviceType']) {
                    result.DeviceType = $scope['selectedDeviceType'];
                }

                if ($scope.filterObject.customBroadcast) {
                    $rootScope.$broadcast($scope.filterObject.customBroadcast, {'filter': $scope.filterResult});
                }

                close(result);
            };
           // $scope.selectedDeviceType = [];

            $scope.filterObject = filterObject;
            //$scope.filterObject.DeviceType = angular.extend(filterDefaults.DeviceType, filterObject);










            $scope.init = function (fo) {
                $scope.guid_Empty = conf_guidEmpty;

                if ($scope.filterObject.Device) {
                    __Device.$getAll().$then(function (data) {
                        // Filter Devices...
                        var f;


                        $scope.filterObject.Device.list = data;
                    });
                }
                if ($scope.filterObject.DeviceType) {
                    if ($scope.filterObject.DeviceType.list) {
                        $scope.DeviceTypes = $scope.filterObject.DeviceType.list;
                    } else if ($scope.filterObject.DeviceType.localizedEnumValues) {
                        $scope.DeviceTypes = $scope.filterObject.DeviceType.localizedEnumValues[0].LocalizedEnumValues;
                    } else {
                        // Set Default DeviceTypes
                        $scope.DeviceTypes = angular.merge(ENUM.getDeviceTypesByFilter(3),ENUM.getDeviceTypesByFilter(4));
                    }

                    if ($scope.filterObject.DeviceType.selected) {
                        $scope.selectedDeviceType = angular.copy($scope.filterObject.DeviceType.selected);
                    } else {
                        $scope.selectedDeviceType = [];
                    }

                    if ($scope.DeviceTypes) {
                        for (var key in $scope.DeviceTypes) {
                            if ($scope.DeviceTypes.hasOwnProperty(key)) {
                                if( $scope.DeviceTypes[key]) {
                                    $scope.DeviceTypes[key].$UI = {};
                                    if ($scope.filterObject.DeviceType.selected && $scope.filterObject.DeviceType.selectable == 'multiple' && $scope.filterObject.DeviceType.selected.indexOf(key) >= 0) {
                                        $scope.DeviceTypes[key].$UI.checked = true;
                                    }
                                }
                            }

                        }
                    }

                }
            };
            $scope.init();


        }]);
